import { Avatar, Button, Card, Col, Comment, Row, Tag, Timeline, Tooltip } from 'antd'
import Editor from '../../../components/Common/TimelineFeed/Editor'
import CustomSpin from '../../../elements/CustomSpin'
import _ from 'lodash'
import moment from 'moment'
import React from 'react'

const DatetimeComponent = ({ timestamp }) => {
  console.log(timestamp)
  return (
    <Tooltip title={moment(timestamp).format('YYYY-MM-DD HH:mm:ss')}>
      <span>{moment(timestamp).fromNow()}</span>
    </Tooltip>
  )
}

function TimelineFeed(props) {
  const FeedCard = (props) => {
    const { post, show, setShow, setShowMain, fetch, hideNotification } = props
    const Title = (
      <div>
        <Avatar shape="square" size={48} icon="user" />
        <span style={{ marginLeft: 15, color: '#14171A', fontSize: '16px' }}>{_.get(post, 'name.fn')}</span>
        <span
          style={{
            marginLeft: 15,
            color: '#657786',
            fontSize: '14px',
          }}>
          <DatetimeComponent timestamp={post.date} />
        </span>
        {post.tag && (
          <span style={{ marginLeft: 15 }}>
            <Tag color="magenta">{post.tag}</Tag>
          </span>
        )}
      </div>
    )
    const Extra = (
      <span
        onClick={() => {
          setShow(show === post._id ? false : post._id)
          setShowMain(false)
        }}
        key="comment-basic-reply-to">
        {show === post._id ? 'Hide Editor' : 'Reply'}
      </span>
    )

    return (
      <div className="flex-1">
        <Card title={Title} extra={Extra}>
          <Editor {...{ hideNotification, show, fetch, postId: post._id, owner: post.owner._id }} />
          <p
            style={{
              color: '#0d1a26',
              fontSize: '18px',
              margin: 20,
              marginBottom: 30,
            }}>
            {post.comment}
          </p>
          <ReplayComments postId={post._id} />
        </Card>
      </div>
    )
  }
  const ReplayComments = ({ postId }) => {
    const comments = props.getPostReplay(postId)
    return comments.map((comment) => <ReplayCard key={comment._id} {...{ comment }} />)
  }
  const ReplayCard = ({ comment }) => {
    return (
      <Comment
        author={<a>{_.get(comment, 'name.fn')}</a>}
        avatar={<Avatar shape="square" size={32} icon="user" />}
        content={comment.comment}
        datetime={<DatetimeComponent timestamp={comment.timestamp} />}
      />
    )
  }

  const {
    posts,
    fetch,
    fetching,
    owner,
    show,
    setShow,
    setShowMain,
    hideNotification,
    showMain,
    submitNotification,
  } = props
  return (
    <CustomSpin spinning={fetching}>
      <Timeline>
        <div className="flex flex-col space-y-4 max-w-2xl py-12 m-auto">
          <Button
            type="primary"
            onClick={() => {
              setShow(false)
              setShowMain(!showMain)
            }}>
            {showMain ? 'HIDE EDITOR' : 'POST A MESSAGE'}
          </Button>
          <div className="px-5">
            <Editor {...{ hideNotification, owner, fetch, show: showMain, submitNotification }} />
          </div>
          {posts && posts.map((d) => <FeedCard post={d} {...props} />)}
        </div>
      </Timeline>
    </CustomSpin>
  )
}

export default TimelineFeed
